import { locatorServiceAPI } from 'shared/services';

import { RoadsideService } from '../types';

export const roadsideServicesAPI = {
  getRoadsideServices: () => locatorServiceAPI.get<RoadsideService[]>('roadside-services')
};
